import { render, staticRenderFns } from "./LoanSummaryFIIcon.vue?vue&type=template&id=b549f0fc&scoped=true&"
import script from "./LoanSummaryFIIcon.vue?vue&type=script&lang=ts&"
export * from "./LoanSummaryFIIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b549f0fc",
  null
  
)

export default component.exports